<template>
	<transition
			appear
			:appear-active-class="$_pgTtlLyt_stylePageTitleLayoutAnimation()">
		<v-row no-gutters>
			<v-col>
				<v-row	:class="$_pgTtlLyt_infoPageHidePageContents ? 'rowTop_' : 'rowNoTop_'"
						no-gutters>
					<v-col>
						<v-sheet
								class="sheet_"
								:style="$_pgTtlLyt_stylePageTitleSheetStyle()">
							<v-row	class="row_"
									align="center"
									justify="center"
									no-gutters>
								<v-col>
									<v-card color="transparent" flat>
										<!-- title -->
										<template v-if="$_pgTtlLyt_langPageTitle">
											<v-card-title>
												<v-row dense>
													<v-col class="center">
														<center>
															<span	class="display-1"
																	v-html="$_pgTtlLyt_langPageTitle" />
														</center>
													</v-col>
												</v-row>
											</v-card-title>
										</template>
										<!-- sub title -->
										<template v-if="$_pgTtlLyt_langPageSubTitle">
											<v-card-text>
												<v-row dense>
													<v-col class="center">
														<center>
															<span	class="subtitle-1"
																	v-html="$_pgTtlLyt_langPageSubTitle" />
														</center>
													</v-col>
												</v-row>
											</v-card-text>
										</template>
										<!-- button -->
										<template v-if="$_pgTtlLyt_langPageTitleButton">
											<v-card-actions>
												<v-row dense>
													<v-col class="center">
														<!-- logged in -->
														<template v-if="$_pgTtlLyt_currentUser">
															<v-btn	class="customVBtn caption"
																	:block="$_pgTtlLyt_stylePageTitleButtonBlock"
																	:color="$_pgTtlLyt_stylePageTitleButtonColor"
																	:dark="$_pgTtlLyt_stylePageTitleButtonDark"
																	:depressed="$_pgTtlLyt_stylePageTitleButtonDepressed"
																	:elevation="$_pgTtlLyt_stylePageTitleButtonElevation"
																	:large="$_pgTtlLyt_stylePageTitleButtonLarge"
																	:light="$_pgTtlLyt_stylePageTitleButtonLight"
																	:outlined="$_pgTtlLyt_stylePageTitleButtonOutlined"
																	:rounded="$_pgTtlLyt_stylePageTitleButtonRounded"
																	:small="$_pgTtlLyt_stylePageTitleButtonSmall"
																	:text="$_pgTtlLyt_stylePageTitleButtonFlat"
																	v-text="$_pgTtlLyt_langPageTitleButtonUser"
																	@click="openLink($_pgTtlLyt_linkPageTitleButtonUser)" />
														</template>
														<!-- not logged in -->
														<template v-else>
															<v-btn	class="customVBtn caption"
																	:block="$_pgTtlLyt_stylePageTitleButtonBlock"
																	:color="$_pgTtlLyt_stylePageTitleButtonColor"
																	:dark="$_pgTtlLyt_stylePageTitleButtonDark"
																	:depressed="$_pgTtlLyt_stylePageTitleButtonDepressed"
																	:elevation="$_pgTtlLyt_stylePageTitleButtonElevation"
																	:large="$_pgTtlLyt_stylePageTitleButtonLarge"
																	:light="$_pgTtlLyt_stylePageTitleButtonLight"
																	:outlined="$_pgTtlLyt_stylePageTitleButtonOutlined"
																	:rounded="$_pgTtlLyt_stylePageTitleButtonRounded"
																	:small="$_pgTtlLyt_stylePageTitleButtonSmall"
																	:text="$_pgTtlLyt_stylePageTitleButtonFlat"
																	v-text="$_pgTtlLyt_langPageTitleButtonNonUser"
																	@click="openLink($_pgTtlLyt_linkPageTitleButtonNonUser)" />
														</template>
													</v-col>
												</v-row>
											</v-card-actions>
										</template>
									</v-card>
								</v-col>
							</v-row>
						</v-sheet>
					</v-col>
				</v-row>
				<!-- button ( only for non-top page ) -->
				<template v-if="!$_pgTtlLyt_infoPageHidePageContents">
					<v-row no-gutters>
						<v-col class="center">
							<v-btn	class="customVBtn"
									icon
									@click="$_pgTtlLyt_down()">
								<v-icon>keyboard_arrow_down</v-icon>
							</v-btn>
						</v-col>
					</v-row>
					<v-row id="down" no-gutters />
				</template>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'PageTitleLayout',
		props: {
			inits: Object
		},
		computed: {
			// current user
			$_pgTtlLyt_currentUser() {
				const self_ = this;
				return self_.getCurrentUser()
			},
			// state
			$_pgTtlLyt_statePageName() {
				const self_ = this;
				return self_.getPageState('name')
			},
			$_pgTtlLyt_statePageType() {
				const self_ = this;
				return self_.getPageState('type')
			},
			// page info
			$_pgTtlLyt_pageInits() {
				const self_ = this;
				return self_.getPageInits(self_.$_pgTtlLyt_statePageName)
			},
			$_pgTtlLyt_infoPageHidePageContents() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_pgTtlLyt_pageInits, 'hidePageContents')
			},
			// lang
			$_pgTtlLyt_langPageTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'pageTitle')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_pgTtlLyt_langPageSubTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'pageSubTitle')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_pgTtlLyt_langPageTitleButton() {
				const self_ = this;
				return self_.getInitsLangVal(self_.inits, 'pageTitleButton')
			},
			$_pgTtlLyt_langPageTitleButtonNonUser() {
				const self_ = this;
				const button_ = self_.$_pgTtlLyt_langPageTitleButton;
				if(self_.isFalse(button_)) { return null}
				if(self_.isObject(button_)) { 
					return self_.getLangsVal(button_.nonUser)
				} else {
					return self_.getLangsVal(button_)
				}
			},
			$_pgTtlLyt_langPageTitleButtonUser() {
				const self_ = this;
				const button_ = self_.$_pgTtlLyt_langPageTitleButton;
				if(self_.isFalse(button_)) { return null}
				if(self_.isObject(button_)) { 
					return self_.getLangsVal(button_.user)
				} else {
					return self_.getLangsVal(button_)
				}
			},
			// link
			$_pgTtlLyt_linkPageTitleButton() {
				const self_ = this;
				return self_.getInitsLinkVal(self_.inits, 'pageTitleButton')
			},
			$_pgTtlLyt_linkPageTitleButtonNonUser() {
				const self_ = this;
				const link_ = self_.$_pgTtlLyt_linkPageTitleButton
				if(self_.isFalse(link_)) { return null }
				if(self_.isFalse(link_.nonUser)) {
					return link_
				} else { return link_.nonUser }
			},
			$_pgTtlLyt_linkPageTitleButtonUser() {
				const self_ = this;
				const link_ = self_.$_pgTtlLyt_linkPageTitleButton
				if(self_.isFalse(link_)) { return null }
				if(self_.isFalse(link_.user)) {
					return link_
				} else { return link_.user }
			},
			// style
			$_pgTtlLyt_stylePageTitleLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageTitleLayout')
				}
			},
			$_pgTtlLyt_stylePageTitleLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_pgTtlLyt_stylePageTitleLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_pgTtlLyt_stylePageTitleSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'pageTitleSheet')
			},
			$_pgTtlLyt_stylePageTitleSheetStyle() {
				const self_ = this;
				return () => {
					const sheet_ = self_.$_pgTtlLyt_stylePageTitleSheet;
					if(self_.isFalse(sheet_)) { return null }
					return self_.getStylesVal(sheet_.style)
				}
			},
			$_pgTtlLyt_stylePageTitleButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'pageTitleButton')
			},
			$_pgTtlLyt_stylePageTitleButtonBlock() {
				const self_ = this;
				const style_ = self_.$_pgTtlLyt_stylePageTitleButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.block)
			},
			$_pgTtlLyt_stylePageTitleButtonColor() {
				const self_ = this;
				const style_ =self_.$_pgTtlLyt_stylePageTitleButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_pgTtlLyt_stylePageTitleButtonDark() {
				const self_ = this;
				const style_ = self_.$_pgTtlLyt_stylePageTitleButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_pgTtlLyt_stylePageTitleButtonDepressed() {
				const self_ = this;
				const style_ = self_.$_pgTtlLyt_stylePageTitleButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.depressed)
			},
			$_pgTtlLyt_stylePageTitleButtonElevation() {
				const self_ = this;
				const style_ = self_.$_pgTtlLyt_stylePageTitleButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.elevation)
			},
			$_pgTtlLyt_stylePageTitleButtonFlat() {
				const self_ = this;
				const style_ = self_.$_pgTtlLyt_stylePageTitleButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_pgTtlLyt_stylePageTitleButtonLarge() {
				const self_ = this;
				const style_ = self_.$_pgTtlLyt_stylePageTitleButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.large)
			},
			$_pgTtlLyt_stylePageTitleButtonLight() {
				const self_ = this;
				const style_ = self_.$_pgTtlLyt_stylePageTitleButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_pgTtlLyt_stylePageTitleButtonOutlined() {
				const self_ = this;
				const style_ = self_.$_pgTtlLyt_stylePageTitleButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_pgTtlLyt_stylePageTitleButtonRounded() {
				const self_ = this;
				const style_ = self_.$_pgTtlLyt_stylePageTitleButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.rounded)
			},
			$_pgTtlLyt_stylePageTitleButtonSmall() {
				const self_ = this;
				const style_ = self_.$_pgTtlLyt_stylePageTitleButton;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.small)
			}
		},
		methods: {
			$_pgTtlLyt_down() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;
				vuetify_.goTo('#down')
			}
		}
	}
</script>

<style scoped>
	@media screen and (min-width:960px) {
		.rowTop_ {
			height: calc(100vh - 24px);
			margin-top: -64px;
		}
	}
	@media screen and (max-width:959px) {
		.rowTop_ {
			height: calc(100vh - 16px);
			margin-top: -56px;
		}
	}
	.rowNoTop_ {
		height: calc(100vh - 36px);
	}
	@media screen and (min-width:960px) {
		.rowNoTop_ {
			margin-top: -64px;
		}
	}
	@media screen and (max-width:959px) {
		.rowNoTop_ {
			margin-top: -56px;
		}
	}
	.sheet_ {
		height: 100vh;
		width: 100vw;
		position: absolute;
		left: 0;

		background-color: transparent;
		background-position: center top;
		background-attachment: fixed;
		background-size: cover;
	}
	@media screen and (min-width:960px) {
		.sheet_ {
			top: -64px;
			padding-top: 64px;
		}
	}
	@media screen and (max-width:959px) {
		.sheet_ {
			top: -56px;
			padding-top: 56px;
		}
	}
	.row_ {
		height: 100%;
	}
</style>
